var map = {
	"./s.svg": "e06f",
	"./ss(1).svg": "406f",
	"./ss.svg": "e400",
	"./ssss.svg": "96dd",
	"./sswess.svg": "67ad",
	"./信永中和logo@3x备份.svg": "009b",
	"./形状结合(1).svg": "1706",
	"./形状结合.svg": "92e6",
	"./画板(1).svg": "4cce",
	"./画板(2).svg": "3dc4",
	"./画板.svg": "c18e",
	"./矩形(1).svg": "a8dd",
	"./矩形.svg": "1cc0",
	"./编组 23.svg": "42c8",
	"./路径.svg": "3416"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";